const ITEMS = [
  "IRP Apportioned Plates", "IFTA Quarterly Returns", "Form 2290 E-File", "MC Authority in 3 Weeks",
  "UCR Registration", "BOC-3 Filing", "Hazmat Permits", "KY / NM / NY / OR Permits",
  "DOT Number Setup", "LLC & Corporation Formation", "Dispatch Support", "Audit Defense",
];

export default function Ticker() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="bg-[#F97316] overflow-hidden border-y border-[#EA580C]" data-testid="services-ticker">
      <div className="flex w-max animate-marquee py-3">
        {row.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-display text-sm font-bold uppercase tracking-widest text-[#0B132B] px-6">{item}</span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#0B132B]/40" />
          </span>
        ))}
      </div>
    </div>
  );
}
